import React, { useState } from "react";
import Header2 from "../../layout/Header2";
import Footer from "../../layout/Footer";

const TeamManagement = () => {
  const [activeTab, setActiveTab] = useState('text');
  return (
    <>
      <Header2 />

      <div className="w-full flex justify-center md:mt-40 mb-24 font-mont xxl:mt-[152px] lg:mt-[145px] mt-[100px]">
        <div className="w-[90%] max-w-[1400px] items-start flex flex-col font-medium gap-7">

          {/* Tabs */}
          <div className="w-full border-b border-gray-200 mb-6">
            <div className="flex">
              <button
                className={`py-2 px-4 font-semibold ${activeTab === 'text' ? 'text-cherry border-b-2 border-cherry' : 'text-gray-500'
                  }`}
                onClick={() => setActiveTab('text')}
              >
                Text templates
              </button>
              <button
                className={`py-2 px-4 font-semibold ${activeTab === 'email' ? 'text-cherry border-b-2 border-cherry' : 'text-gray-500'
                  }`}
                onClick={() => setActiveTab('email')}
              >
                Email templates
              </button>
            </div>
          </div>

          {/* Tab Content */}
          {activeTab === 'email' && (
              <>
               <h1 className="text-[23px] sm:text-[28px] font-bold">
                 <span className="text-cherry">EXAMPLE <span className="text-blue-700 underline">EMAIL</span>  TEMPLATES |</span> <span className="text-blue-700">HARRIS COUNTY ELECTION</span>
                 <h1 className="text-[23px] sm:text-[28px] font-bold text-cherry w-full text-center">
                    MAY 3, 2025 
                 </h1>
               </h1>
 
               <div className="flex flex-col gap-4">
                 <div>
                   <h3 className="text-[21px] font-bold">
                     EARLY VOTING IS <span className="text-cherry">8 DAYS</span>
                   </h3>
                   <h3 className="text-[21px] font-bold">
                   ELECTION DAY IS ALWAYS 3 DAYS AFTER EARLY VOTING ENDS
                   </h3>
                 </div>
 
                 <div>
                   <h3 className="font-bold text-lg">
                     <span className="text-cherry">5 EMAIL TEMPLATES</span> TO  <span className="text-cherry">COPY & PASTE </span> TO EMAIL YOUR LIST OF VOTERS 
                   </h3>
                 </div>
                 <div>
                   <h3 className="font-bold text-lg">
                   YOU CAN EDIT THESE EMAILS TO ADD VOTER GUIDES, ETC.
                   </h3>
                 </div>
               </div>
               <div className="flex flex-col gap-4">
                 <div>
                   <h1 className="font-bold mb-3 text-2xl text-cherry">
                   1. EMAIL TO SEND 1 OR 2 WEEKS BEFORE EARLY VOTING
                   </h1>
                   <h5 className="font-bold">
                     ELECTION INFO from <a
                     href="https://www.springbranchisd.com/about/board-of-trustees/elections/current-elections"
                     className="underline text-blue-600"
                     target="_blank"
                   >
                     Fired Up To Vote
                   </a>
                   </h5>
                   <h5 className="font-bold">
                     <span className="text-cherry">COPY & PASTE </span> the email below to your list of voters
                   </h5>
                 </div>
 
                 <div>
                   <h5 className="font-bold text-lg">
                   IMPORTANT HARRIS COUNTY ELECTION  
                   </h5>
                 </div>
                 <div className="font-bold">
                   <div className="text-cherry">
                   ELECTION FOR
                   </div>
                   <div>
                    <ul class='list-disc pl-6'>
                      <li>
                        Several School Districts Board of Trustees
                      </li>
                      <li>
                        MUDs and Emergency Services
                      </li>
                    </ul>
                   </div>
                 </div>
                 <div className="font-bold text-cherry">
                     MARK YOUR CALENDAR! 
                 </div>
                 <div className="font-bold  text-cherry">
                 EARLY VOTING - 8 DAYS
                 </div>
                 <div className="font-bold">
                   <div>TUESDAY APRIL 22 - TUESDAY APRIL 29 </div>
                   <div>Polls are open daily 7am - 7pm</div>
                 </div>
                 <div className="font-bold">
                   <div>SUNDAY APRIL 27 </div>
                   <div>Polls are open Noon - 7pm</div>
                 </div>
                 <div className="font-bold">
                   <div className="text-cherry">ELECTION DAY</div>
                   <div>SATURDAY MAY 3</div>
                   <div>Polls open 7am - 7pm</div>
                 </div>
                 <div className="font-bold">
                  CLICK <a
                     href="https://www.harrisvotes.com/Vote-Centers/lang/en-US"
                     className="underline text-blue-600"
                     target="_blank"
                   >
                     HERE
                   </a> For <span className="text-cherry">poll locations</span>
                 </div>
                 <div className="font-bold">
                  CLICK <a
                     href="https://www.harrisvotes.com/Vote-Centers/lang/en-US"
                     className="underline text-blue-600"
                     target="_blank"
                   >
                     What’s on My Ballot 
                   </a> to see your ballot 
                 </div>
               </div>
               <div className="flex flex-col gap-4">
                 <div>
                   <h1 className="font-bold mb-3 text-2xl text-cherry">
                    2. EMAIL TO SEND <span className="underline">1 DAY</span> AFTER EARLY VOTING STARTS
                   </h1>
                   <h5 className="font-bold">
                     ELECTION INFO from <a
                     href="https://www.springbranchisd.com/about/board-of-trustees/elections/current-elections"
                     className="underline text-blue-600"
                     target="_blank"
                   >
                     Fired Up To Vote
                   </a>
                   </h5>
                   <h5 className="font-bold">
                     <span className="text-cherry">COPY & PASTE </span> the email below to your list of voters
                   </h5>
                 </div>

                <div className="font-bold">
                  <div>Early Voting started 1 DAY AGO!</div>
                  <div>Get to the polls this week!</div>
                  <div>Avoid the crowds on Election Day!</div>
                 </div>  
              
                 <div>
                   <h5 className="font-bold text-lg">
                   HARRIS COUNTY ELECTION INFO  <a
                     href="https://www.harrisvotes.com/Voter/View-information-for-upcoming-Elections"
                     className="underline text-blue-600"
                     target="_blank"
                   >
                     HERE
                   </a>
                   </h5>
                 </div>
                 <div className="font-bold">
                  <div className="font-bold text-cherry">
                    POLLS INFO 
                  </div>
                   <div>WEDNESDAY APRIL 23 - TUESDAY APRIL 29 </div>
                   <div>Polls are open 7am - 7pm </div>
                 </div>
                 <div className="font-bold">
                   <div>SUNDAY APRIL 27 </div>
                   <div>Polls are open Noon - 7pm</div>
                 </div>
                 <div className="font-bold">
                  CLICK <a
                     href="https://www.harrisvotes.com/Vote-Centers/lang/en-US"
                     className="underline text-blue-600"
                     target="_blank"
                   >
                     HERE
                   </a> to see Early Voting locations
                  <div className="font-bold">
                    CLICK <a
                      href="https://www.harrisvotes.com/Voter/Whats-on-my-Ballot"
                      className="underline text-blue-600"
                      target="_blank"
                    >
                      WHAT’S ON MY BALLOT?  
                    </a>
                  </div>
                 </div>
                 <div className="font-bold">
                  Remember to Vote in every single race on <a
                     href="https://www.harrisvotes.com/Voter/Whats-on-my-Ballot"
                     className="underline text-blue-600"
                     target="_blank"
                   >
                     your ballot  
                   </a>
                 </div>
               </div>
               <div className="flex flex-col gap-4">
                 <div>
                   <h1 className="font-bold mb-3 text-2xl text-cherry">
                   3. EMAIL TO SEND <span className="underline">4 DAYS </span> BEFORE EV ENDS
                   </h1>
                   <h5 className="font-bold">
                     ELECTION INFO from <a
                     href="https://www.springbranchisd.com/about/board-of-trustees/elections/current-elections"
                     className="underline text-blue-600"
                     target="_blank"
                   >
                     Fired Up To Vote
                   </a>
                   </h5>
                   <h5 className="font-bold">
                     <span className="text-cherry">COPY & PASTE </span> the email below to your list of voters
                   </h5>
                 </div>

                <div className="font-bold">
                  <div className="text-cherry">A Friendly Reminder!</div>
                  <div>Only <span className="text-cherry">4 days</span> left of Early Voting!</div>
                  <div>Get to the polls by TUESDAY April 29</div>
                 </div>  
              
                 <div>
                   <h5 className="font-bold text-lg">
                   HARRIS COUNTY <span className="text-cherry">ELECTION INFO</span>  <a
                     href="https://www.harrisvotes.com/Voter/View-information-for-upcoming-Elections"
                     className="underline text-blue-600"
                     target="_blank"
                   >
                     HERE
                   </a>
                   </h5>
                 </div>
                 <div className="font-bold">
                  <div className="font-bold text-cherry">
                    POLLS OPEN INFO 
                  </div>
                  <ul className="list-disc pl-6">
                    <li>SAT. April 26th to TUES. April 29 | Polls open 7am - 7 pm</li>
                    <li>SUN. April 27 | Polls open  Noon - 7 pm</li>
                  </ul>
                 </div>
                 <div className="font-bold">
                  <span className="text-cherry">Voting Locations</span> are <a
                     href="https://www.harrisvotes.com/Vote-Centers/lang/en-US"
                     className="underline text-blue-600"
                     target="_blank"
                   >
                     HERE
                   </a>
                  <div className="font-bold">
                    Your <span className="text-cherry">Sample Ballot</span> is <a
                      href="https://www.harrisvotes.com/Voter/Whats-on-my-Ballot"
                      className="underline text-blue-600"
                      target="_blank"
                    >
                      HERE 
                    </a>
                  </div>
                 </div>
                 <div className="font-bold">
                  Your vote matters! Make sure it counts by voting!
                 </div>
               </div>
               <div className="flex flex-col gap-4">
                 <div>
                   <h1 className="font-bold mb-3 text-2xl text-cherry">
                   4. EMAIL TO SEND THE <span className="underline">LAST DAY </span> OF EARLY VOTING
                   </h1>
                   <h5 className="font-bold">
                     ELECTION INFO from <a
                     href="https://www.springbranchisd.com/about/board-of-trustees/elections/current-elections"
                     className="underline text-blue-600"
                     target="_blank"
                   >
                     Fired Up To Vote
                   </a>
                   </h5>
                   <h5 className="font-bold">
                     <span className="text-cherry">COPY & PASTE </span> the email below to your list of voters
                   </h5>
                 </div>

                <div className="font-bold">
                  <div>TODAY, TUES. 4/29 - LAST DAY of EARLY VOTING!</div>
                 </div>  
              
                 <div>
                   <h5 className="font-bold text-lg">
                   HARRIS COUNTY ELECTION INFO  <a
                     href="https://www.harrisvotes.com/Voter/View-information-for-upcoming-Elections"
                     className="underline text-blue-600"
                     target="_blank"
                   >
                     HERE
                   </a>
                   </h5>
                 </div>
                 <div className="font-bold">
                  <div><span className="text-cherry">Polls</span> are open 7am - 7pm</div>
                  <div>   Here is  <span className="text-cherry">WHERE</span> to <a
                     href="https://www.harrisvotes.com/Vote-Centers/lang/en-US"
                     className="underline text-blue-600"
                     target="_blank"
                   >
                     VOTE
                   </a></div>
                 </div>
                  <div className="font-bold">
                    View your <span className="text-cherry">ballot</span> at <a
                      href="https://www.harrisvotes.com/Voter/Whats-on-my-Ballot"
                      className="underline text-blue-600"
                      target="_blank"
                    >
                      What’s on My Ballot?
                    </a>
                  </div>
                 <div className="font-bold">
                  VOTE in every race and on every proposition!
                 </div>
                 <div className="font-bold">
                    <div className="text-cherry">ELECTION DAY</div>
                    <div>Saturday May 3</div>
                 </div>
               </div>
               <div className="flex flex-col gap-4">
                 <div>
                   <h1 className="font-bold mb-3 text-2xl text-cherry">
                   5. EMAIL TO SEND <span className="underline">THE DAY BEFORE  </span> ELECTION DAY
                   </h1>
                   <h5 className="font-bold">
                     ELECTION INFO from <a
                     href="https://www.springbranchisd.com/about/board-of-trustees/elections/current-elections"
                     className="underline text-blue-600"
                     target="_blank"
                   >
                     Fired Up To Vote
                   </a>
                   </h5>
                   <h5 className="font-bold">
                     <span className="text-cherry">FORWARD </span> thE  email to your list of voters
                   </h5>
                 </div>

                <div className="font-bold">
                  <div className="text-cherry">LAST CHANCE TO VOTE!</div>
                  <div>YOUR VOTE COUNTS!</div>
                 </div>  
                 <div className="font-bold">
                  <div className="text-cherry">ELECTION DAY </div>
                  <div>SATURDAY MAY 3</div>
                 </div>  
              
                 <div>
                   <h5 className="font-bold text-lg">
                    <span className="text-cherry">ELECTION INFO</span>  <a
                     href="https://www.harrisvotes.com/Voter/View-information-for-upcoming-Elections"
                     className="underline text-blue-600"
                     target="_blank"
                   >
                     HERE
                   </a>
                   </h5>
                 </div>
                 <div className="font-bold">
                  <div><span className="text-cherry">Polls</span> are open 7am - 7pm</div>
                 </div>
                 <div className="font-bold">Here's POLLS <span className="text-cherry">WHERE</span> to <a
                     href="https://www.harrisvotes.com/Vote-Centers/lang/en-US"
                     className="underline text-blue-600"
                     target="_blank"
                   >
                     VOTE
                   </a></div>
                  <div className="font-bold">
                    <span className="text-cherry">VIEW </span> your Ballot at <a
                      href="https://www.harrisvotes.com/Voter/Whats-on-my-Ballot"
                      className="underline text-blue-600"
                      target="_blank"
                    >
                      What’s on My Ballot?
                    </a>
                  </div>
               </div>
             </>
          )}


          {activeTab === "text" && (
            <>
              <h1 className="text-[23px] sm:text-[28px] font-bold">
                <span className="text-cherry">EXAMPLE <span className="text-blue-700">TEXT</span> TEMPLATES |</span> <span className="text-blue-700">HARRIS COUNTY ELECTION</span>
                <h1 className="text-[23px] sm:text-[28px] font-bold text-cherry w-full text-center">
                  MAY 3, 2025 
                </h1>
              </h1>

              <div className="flex flex-col gap-4">
                <div>
                  <h3 className="text-[21px] font-bold">
                    EARLY VOTING (EV) IS <span className="text-cherry">8 DAYS</span>
                  </h3>
                  <h3 className="text-[21px] font-bold">
                  ELECTION DAY IS ALWAYS 3 DAYS AFTER EARLY VOTING ENDS
                  </h3>
                </div>

                <div>
                  <h3 className="font-bold text-lg">
                    <span className="text-cherry">5 TEXT TEMPLATES</span> TO SEND TO YOUR LIST OF VOTERS 
                  </h3>
                </div>
              </div>
              <div className="flex flex-col gap-4">
                <div>
                  <h1 className="font-bold mb-3 text-2xl text-cherry">
                    1. TEXT FOR 1 TO 2 WEEKS BEFORE EARLY VOTING
                  </h1>
                  <h5 className="font-bold">
                    ELECTION INFO from <a
                    href="https://www.springbranchisd.com/about/board-of-trustees/elections/current-elections"
                    className="underline text-blue-600"
                    target="_blank"
                  >
                    Fired Up To Vote
                  </a>
                  </h5>
                  <h5 className="font-bold">
                    <span className="text-cherry">SEND</span> this TEXT below to your list of voters
                  </h5>
                </div>

                <div>
                  <h5 className="font-bold text-lg">
                  IMPORTANT HARRIS COUNTY ELECTION 
                  </h5>
                </div>
                <div className="font-bold">
                  <div>
                    ELECTION FOR
                  </div>
                  <div>
                    1) Several School Districts Board of Trustees
                  </div>
                  <div>
                    2) MUDs and Emergency Services
                  </div>
                </div>
                <div className="font-bold">
                    MARK YOUR CALENDAR 
                </div>
                <div className="font-bold underline">
                  EARLY VOTING DATES & TIMES
                </div>
                <div className="font-bold">
                  <div>TUE. 4/22 - TUES. 4/ 29 </div>
                  <div>Polls open  7am - 7pm</div>
                  <div>SUN 4/27 </div>
                  <div>Polls open Noon - 7 pm</div>
                </div>
                <div className="font-bold">
                  <div>Find Your <a
                      href="https://www.harrisvotes.com/Vote-Centers"
                      className="underline text-blue-600"
                      target="_blank"
                      >
                      Poll
                    </a>
                  </div>
                  <div> Tap <a
                      href="https://www.harrisvotes.com/Vote-Centers"
                      className="underline text-blue-600"
                      target="_blank"
                      >
                      www.harrisvotes.com/Vote-Centers
                    </a>
                  </div>
                </div>
                <div className="font-bold">
                  <div>View Your <a
                      href="https://www.harrisvotes.com/Voter/Whats-on-my-Ballot"
                      className="underline text-blue-600"
                      target="_blank"
                      >
                      Ballot
                    </a>
                  </div>
                  <div> Tap <a
                      href="https://www.harrisvotes.com/Voter/Whats-on-my-Ballot"
                      className="underline text-blue-600"
                      target="_blank"
                      >
                      www.harrisvotes.com/Voter/Whats-on-my-Ballot?
                    </a>
                  </div>
                </div>
                <div className="font-bold">
                  <div className="underline">ELECTION DAY</div>
                  <div>SAT MAY 3</div>
                  <div>Polls open 7am - 7pm</div>
                </div>
              </div>
              <div className="flex flex-col gap-4">
                <div>
                  <h1 className="font-bold mb-3 text-2xl text-cherry">
                    2. TEXT FOR 2ND DAY AFTER EV BEGINS
                  </h1>
                  <h5 className="font-bold">
                    ELECTION INFO from <a
                    href="https://www.springbranchisd.com/about/board-of-trustees/elections/current-elections"
                    className="underline text-blue-600"
                    target="_blank"
                  >
                    Fired Up To Vote
                  </a>
                  </h5>
                  <h5 className="font-bold">
                    <span className="text-cherry">SEND</span> this TEXT below to your list of voters
                  </h5>
                </div>

                <div>
                  <h5 className="font-bold text-lg">
                  Don’t Delay! | Vote Early!
                  </h5>
                </div>
                <div className="font-bold">
                  <div>View Your <a
                      href="https://www.harrisvotes.com/Voter/Whats-on-my-Ballot"
                      className="underline text-blue-600"
                      target="_blank"
                      >
                      Ballot
                    </a>
                  </div>
                  <div> Tap <a
                      href="https://www.harrisvotes.com/Voter/Whats-on-my-Ballot"
                      className="underline text-blue-600"
                      target="_blank"
                      >
                      https://www.harrisvotes.com/Voter/Whats-on-my-Ballot?
                    </a>
                  </div>
                </div>
                <div className="font-bold underline">
                  EARLY VOTING DATES & TIMES
                </div>
                <div className="font-bold">
                  <div>WED 4/23 - TUES 4/29 </div>
                  <div>Polls open till 7am - 7pm</div>
                  <div>SUN 4/27 </div>
                  <div>Open Noon - 7 pm</div>
                </div>
                <div className="font-bold">
                  <div>Find Your <a
                      href="https://www.harrisvotes.com/Vote-Centers"
                      className="underline text-blue-600"
                      target="_blank"
                      >
                      Poll
                    </a>
                  </div>
                  <div> Tap <a
                      href="https://www.harrisvotes.com/Vote-Centers"
                      className="underline text-blue-600"
                      target="_blank"
                      >
                      www.harrisvotes.com/Vote-Centers
                    </a>
                  </div>
                </div>
                <div className="font-bold">
                  <div>View Your <a
                      href="https://www.harrisvotes.com/Voter/Whats-on-my-Ballot"
                      className="underline text-blue-600"
                      target="_blank"
                      >
                      Ballot
                    </a>
                  </div>
                  <div> Tap <a
                      href="https://www.harrisvotes.com/Voter/Whats-on-my-Ballot"
                      className="underline text-blue-600"
                      target="_blank"
                      >
                      www.harrisvotes.com/Voter/Whats-on-my-Ballot?
                    </a>
                  </div>
                </div>
                <div className="font-bold">
                  <div className="underline">ELECTION DAY</div>
                  <div>SAT MAY 3</div>
                  <div>Polls open 7am - 7pm</div>
                </div>
              </div>
              <div className="flex flex-col gap-4">
                <div>
                  <h1 className="font-bold mb-3 text-2xl text-cherry">
                    3. TEXT FOR 4 DAYS BEFORE EV ENDS
                  </h1>
                  <h5 className="font-bold">
                    ELECTION INFO from <a
                    href="https://www.springbranchisd.com/about/board-of-trustees/elections/current-elections"
                    className="underline text-blue-600"
                    target="_blank"
                  >
                    Fired Up To Vote
                  </a>
                  </h5>
                  <h5 className="font-bold">
                    <span className="text-cherry">SEND</span> this TEXT below to your list of voters
                  </h5>
                </div>

                <div>
                  <div className="font-bold text-lg">
                    Harris County Early Voting
                  </div>
                  <div className="font-bold text-lg">
                  Only 4 days left to vote early! 
                  </div>
                  <div className="font-bold text-lg">
                  Vote as soon as you can
                  </div>
                </div>
                <div className="font-bold">
                  <div>Find Your <a
                      href="https://www.harrisvotes.com/Vote-Centers"
                      className="underline text-blue-600"
                      target="_blank"
                      >
                      Poll
                    </a>
                  </div>
                  <div> Tap <a
                      href="https://www.harrisvotes.com/Vote-Centers"
                      className="underline text-blue-600"
                      target="_blank"
                      >
                      www.harrisvotes.com/Vote-Centers
                    </a>
                  </div>
                </div>
                <div className="font-bold">
                  <div>View Your <a
                      href="https://www.harrisvotes.com/Voter/Whats-on-my-Ballot"
                      className="underline text-blue-600"
                      target="_blank"
                      >
                      Ballot
                    </a>
                  </div>
                  <div> Tap <a
                      href="https://www.harrisvotes.com/Voter/Whats-on-my-Ballot"
                      className="underline text-blue-600"
                      target="_blank"
                      >
                      www.harrisvotes.com/Voter/Whats-on-my-Ballot?
                    </a>
                  </div>
                </div>
                <div className="font-bold">
                  <div className="underline">EARLY VOTING DATES & TIMES</div>
                  <div>SAT 4/26 - TUES 4/29</div>
                  <div>Polls open till 7am - 7pm</div>
                </div>
                <div className="font-bold">
                  <div>SUN 4/27</div>
                  <div>Polls open Noon - 7 pm</div>
                </div>
                <div className="font-bold">
                  <div className="underline">ELECTION DAY </div>
                  <div>SAT  MAY 3</div>
                  <div>Polls open 7am - 7pm</div>
                </div>
              </div>
              <div className="flex flex-col gap-4">
                <div>
                  <h1 className="font-bold mb-3 text-2xl text-cherry">
                    4. TEXT FOR LAST DAY OF EV 
                  </h1>
                  <h5 className="font-bold">
                    ELECTION INFO from <a
                    href="https://www.springbranchisd.com/about/board-of-trustees/elections/current-elections"
                    className="underline text-blue-600"
                    target="_blank"
                  >
                    Fired Up To Vote
                  </a>
                  </h5>
                  <h5 className="font-bold">
                    <span className="text-cherry">SEND</span> this TEXT below to your list of voters
                  </h5>
                </div>

                <div>
                  <div className="font-bold text-lg">
                    HARRIS COUNTY ELECTION
                  </div>
                  <div className="font-bold text-lg">
                    Friendly Reminder!
                  </div>
                </div>
                <div>
                  <div className="font-bold text-lg">
                  TODAY LAST DAY OF EARLY VOTING!
                  </div>
                  <div className="font-bold text-lg">
                  Polls open Noon - 7pm
                  </div>
                </div>
                <div className="font-bold">
                  <div>Find Your <a
                      href="https://www.harrisvotes.com/Vote-Centers"
                      className="underline text-blue-600"
                      target="_blank"
                      >
                      Poll
                    </a>
                  </div>
                  <div> Tap <a
                      href="https://www.harrisvotes.com/Vote-Centers"
                      className="underline text-blue-600"
                      target="_blank"
                      >
                      www.harrisvotes.com/Vote-Centers
                    </a>
                  </div>
                </div>
                <div className="font-bold">
                  <div>View Your <a
                      href="https://www.harrisvotes.com/Voter/Whats-on-my-Ballot"
                      className="underline text-blue-600"
                      target="_blank"
                      >
                      Ballot
                    </a>
                  </div>
                  <div> Tap <a
                      href="https://www.harrisvotes.com/Voter/Whats-on-my-Ballot"
                      className="underline text-blue-600"
                      target="_blank"
                      >
                      www.harrisvotes.com/Voter/Whats-on-my-Ballot?
                    </a>
                  </div>
                </div>
                <div className="font-bold">
                  <div className="underline">ELECTION DAY </div>
                  <div>SAT  MAY 3</div>
                  <div>Polls open 7am - 7pm</div>
                </div>
              </div>
              <div className="flex flex-col gap-4">
                <div>
                  <h1 className="font-bold mb-3 text-2xl text-cherry">
                    5. TEXT FOR DAY BEFORE ELECTION DAY
                  </h1>
                  <h5 className="font-bold">
                    ELECTION INFO from <a
                    href="https://www.springbranchisd.com/about/board-of-trustees/elections/current-elections"
                    className="underline text-blue-600"
                    target="_blank"
                  >
                    Fired Up To Vote
                  </a>
                  </h5>
                  <h5 className="font-bold">
                    <span className="text-cherry">SEND</span> this TEXT below to your list of voters
                  </h5>
                </div>

                <div>
                  <div className="font-bold text-lg">
                    HARRIS COUNTY ELECTION
                  </div>
                </div>
                <div>
                  <div className="font-bold text-lg">
                    Tomorrow is Election Day! 
                  </div>
                  <div className="font-bold text-lg">
                    VOTE so your voice can be heard in this important election!
                  </div>
                </div>
                <div className="font-bold">
                  <div>ELECTION DAY </div>
                  <div>SAT  MAY 3</div>
                  <div>Polls open 7am - 7pm</div>
                </div>
                <div className="font-bold">
                  <div>Find the most convenient poll location </div>
                  <div> Tap <a
                      href="https://www.harrisvotes.com/Vote-Centers"
                      className="underline text-blue-600"
                      target="_blank"
                      >
                      www.harrisvotes.com/Vote-Centers
                    </a>
                  </div>
                </div>
                <div className="font-bold">
                  <div>What's on My Ballot?</div>
                  <div> Tap <a
                      href="https://www.harrisvotes.com/Voter/Whats-on-my-Ballot"
                      className="underline text-blue-600"
                      target="_blank"
                      >
                      www.harrisvotes.com/Voter/Whats-on-my-Ballot?
                    </a>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default TeamManagement;
